import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    scrollUp(event) {
        const clickedLink = event.target.closest("a");
        if (clickedLink && clickedLink.getAttribute("aria-disabled") !== "true") {
            this.element.scrollIntoView({
                // behavior: "smooth",
                block: "start"});
        }
    }
}
